<div class="upload-form">

    <div class="upload-form__upload-main-container" *ngIf="evidence && evidence[evidenceIndex]">
        <span *ngIf="evidence && evidence[evidenceIndex].document_omschrijving" class="upload-form__documents-header">{{evidence[evidenceIndex].document_omschrijving }}</span>

        <div class="upload-form__button-container">
            <label *ngIf="evidence[evidenceIndex].document_id !== 'EXDO'" [for]="'upload-input-' + evidenceIndex"
                   class="upload-form__input-label form-file form-file--sm form-file--block form-file--center btn--primary-icon btn--primary-icon--gray"
                   [ngClass]="{'disabled': isDisabled() || (isLoading$ | async)}">

                <img src="/assets/shared/roze_plus_21x20.svg" lazyLoad="/assets/shared/roze_plus_21x20.svg" alt="Roze plus" class="svg-icon svg-icon--s" />
                Upload document
            </label>
            <label for="upload-extra-input" *ngIf="evidence[evidenceIndex].document_id === 'EXDO'" class="upload-form__upload-extra" >
             + Extra bewijs toevoegen
            <input type="file"
                   id="upload-extra-input"
                   class="upload-form__upload-extra-input"
                   ngFileSelect
                   (uploadOutput)="onUploadOutput($event, true)"
                   [uploadInput]="uploadInput"
                   [options]="uploadOptions"
                   [disabled]="isDisabled()">
            </label>
        </div>

        <input type="file"
               [id]="'upload-input-' + evidenceIndex"
               class="upload-form__upload-input"
               ngFileSelect
               (uploadOutput)="onUploadOutput($event)"
               [uploadInput]="uploadInput"
               [options]="uploadOptions"
               [disabled]="isDisabled()">
    </div>
    <div class="upload-form__documents-container" *ngIf="evidence && evidence[evidenceIndex]">
        <div class="upload-form__preview" *ngFor="let item of evidence[evidenceIndex].document">
            <div class="upload-form__preview-container upload-form__preview-container--text">
                <p class="upload-form__preview-item">{{ item.pg_document_bestandsnaam }}</p>
            </div>
            <div class="upload-form__preview-container">
                <div>
                    <svg (click)="onDeleteClick(item)" class="upload-form__preview-item svg-icon svg-icon--s">
                        <use href="assets/icons-ui.svg#verwijder"></use>
                    </svg>
                    <svg class="upload-form__preview-item svg-icon svg-icon--s">
                        <use href="assets/icons-ui.svg#check-closed"></use>
                    </svg>
                </div>
            </div>
        </div>
    </div>

    <cyno-alert [meldingen]="errors.messages" *ngIf="errors"></cyno-alert>
</div>
